import axios from './index.js'
// import store from '@/store'
// function cleanParams (params) {
//   return Object.fromEntries(Object.entries(params).filter(arr => arr[1] || arr[1] === 0))
// }


// 团队成员列表 
export const teamMembers = (params) => {
  return axios.get('/welldbCombine/api/team/members',{
    params
  })
}


// (通用)上传列表  
export const uploadList = (data) => {
  return axios.post('/welldbCombine/api/labelData/upload/list',{
    ...data
  })
}


// (通用)上传标注数据  
export const uploadCreate = (data) => {
  return axios.post('/welldbCombine/api/labelData/upload/create',{
    ...data
  })
}


// 采购经理人员列表 
export const purchaseManagers = () => {
  return axios.get('/welldbCombine/api/labelTask/purchaseManagers')
}



// (通用)根据id获取信息(展示) 
export const forView = (params) => {
  return axios.get('/welldbCombine/api/labelTask/getForView', {
    params
  })
}


// (通用)任务数据分页列表 
export const dataItem = (params) => {
  return axios.get('/welldbCombine/api/labelTask/items', {
    params
  })
}


// (通用)子任务信息(展示) 
export const subForView = (params) => {
  return axios.get('/welldbCombine/api/labelTask/sub/getForView', {
    params
  })
}


// (通用))子任务数据状态统计 
export const subDetail = (params) => {
  return axios.get('/welldbCombine/api/labelTask/sub/detail', {
    params
  })
}




// (运营)PMO人员列表 
export const pmos = () => {
  debugger
  return axios.get('/welldbCombine/api/labelTask/pmos')
}


//(运营)ERP项目列表 
export const projects = (params) => {
  return axios.get('/welldbCombine/api/labelTask/projects',{
    params
  })
}



//(运营)子任务标注信息导出  
export const exportLabel = (params) => {
  return axios.get('/welldbCombine/api/labelData/export/label',{
    params
  })
}



//(运营))数据合并任务列表 
export const mergeTasks = (params) => {
  return axios.get('/welldbCombine/api/labelTask/merge/tasks',{
    params
  })
}


//(运营)根据子任务id获取有相同数据集的任务列表
export const datasetTasks = (labelTaskSubId) => {
  debugger
  return axios.get('/welldbCombine/api/labelTask/same/dataset/tasks',{
    params:{
      labelTaskSubId
    }
  })
}

//(运营))数据合并 
export const mergeCreate = (data) => {
  return axios.post('/welldbCombine/api/labelTask/merge/create',{
    ...data
  })
}




//(运营)纯线下任务标注完成打回
export const labelRepulse = (labelTaskId) => {
  return axios.get('/welldbCombine/api/labelTask/labelRepulse', {
    params:{
      labelTaskId
    }
  })
}




// (运营)新增任务
export const createTask = (data) => {
  return axios.post('/welldbCombine/api/labelTask/create', {
    ...data
  })
}

// 获取修任务数据  (运营)根据id获取信息(编辑) 
export const getForEdit = (params) => {
  return axios.get('/welldbCombine/api/labelTask/getForEdit', {
    params
  })
}


// (运营)任务分页列表 
export const pageForOperation = (params) => {
  return axios.get('/welldbCombine/api/labelTask/page', {
    params
  })
}


// (运营)主任务提交审批 
export const taskApprove = (params) => {
  return axios.get('/welldbCombine/api/labelTask/submit', {
    params
  })
}


// (运营)删除任务 
export const labelTaskDel = (params) => {
  return axios.delete('/welldbCombine/api/labelTask/del', {
    params
  })
}

// (运营)编辑任务  
export const labelTaskEdit = (data) => {
  return axios.put('/welldbCombine/api/labelTask/edit', {
    ...data
  })
}


// 运营)初验数据 
export const acceptance = (data) => {
  return axios.post('/welldbCombine/api/labelTask/detail/acceptance', {
    ...data
  })
}



//((运营)子任务标注信息导出 
export const lablelExport = (params) => {
  return axios.get('/welldbCombine/api/labelData/export/label', {
    params
  })
}


// (运营)终止 
export const labelTaskStop = (data) => {
  return axios.post('welldbCombine/api/labelTask/stop', { 
    ...data
  })
}



// (运营)初验结束  
export const labelTaskCompleted = (params) => {
  return axios.get('welldbCombine/api/labelTask/completed', {
    params
  })
}


// (运营)完成  
export const labelTaskComplet = (params) => {
  return axios.get('welldbCombine/api/labelTask/complet', {
    params
  })
}


// (服务商)任务分页列表 
export const pageForServer = (params) => {
  return axios.get('/welldbCombine/api/labelTask/pageForServer', {
    params
  })
}


//(服务商)子任务列表   
export const subpageForServer = (params) => {
  return axios.get('/welldbCombine/api/labelTask/sub/pageForServer', {
    params
  })
}



//(服务商)子任务原始数据导出 
export const exportItems = (params) => {
  return axios.get('/welldbCombine/api/labelData/export/items',{
    params
  })
}

//(服务商)纯线下任务标注完成
export const otherLabelCompleted = (labelTaskId) => {
  return axios.get('/welldbCombine/api/labelTask/labelCompleted', {
    params:{
      labelTaskId
    }
  })
}

//(服务商)编辑任务上传文件地址
export const editUploadPath = (data) => {
  return axios.put('/welldbCombine/api/labelTask/editUploadPath', {
    ...data
  })
}

//(服务商)移除任务上传文件地址
export const removeUploadPath = (data) => {
  return axios.post('/welldbCombine/api/labelTask/removeUploadPath', {
    ...data
  })
}


//(服务商)增加任务上传文件地址
export const addUploadPath = (data) => {
  return axios.post('/welldbCombine/api/labelTask/addUploadPath', {
    ...data
  })
}






//(服务商)初验开始 
export const acceptStart = (params) => {
  return axios.get('/welldbCombine/api/labelTask/sub/accept/start', {
    params
  })
}


//(服务商)初验结束  
export const completed = (params) => {
  return axios.get('/welldbCombine/api/labelTask/sub/accept/completed', {
    params
  })
}


//(服务商))子任务提交初验   
export const subSubmit = (params) => {
  return axios.get('/welldbCombine/api/labelTask/sub/submit', {
    params
  })
}


//(服务商)标注开始 
export const labelStart = (params) => {
  return axios.get('/welldbCombine/api/labelTask/sub/label/start', {
    params
  })
}


//(服务商)标注数据 
export const label = (data) => {
  return axios.post('/welldbCombine/api/labelTask/detail/label', {
    ...data
  })
}


//(服务商)标注完成  
export const labelCompleted = (params) => {
  return axios.get('/welldbCombine/api/labelTask/sub/label/completed', {
    params
  })
}


//(服务商)质检开始   
export const inspectStart = (params) => {
  return axios.get('/welldbCombine/api/labelTask/sub/inspect/start', {
    params
  })
}


//(服务商)质检完成   
export const inspectCompleted = (params) => {
  return axios.get('/welldbCombine/api/labelTask/sub/inspect/completed', {
    params
  })
}


//(服务商)质检数据   
export const inspect = (data) => {
  return axios.post('/welldbCombine/api/labelTask/detail/inspect', {
    ...data
  })
}


//(服务商)任务接收 
export const labelTaskReceive = (params) => {
  return axios.get('/welldbCombine/api/labelTask/receive', {
    params
  })
}

//(服务商)任务拒绝
export const labelTaskReject = (params) => {
  return axios.get('/welldbCombine/api/labelTask/reject', {
    params
  })
}


//(服务商)任务拆分 
export const labelTaskSplit = (params) => {
  return axios.get('/welldbCombine/api/labelTask/split', {
    params
  })
}

// (服务商)子任务指派 
export const labelTaskAssign = (params) => {
  return axios.get('/welldbCombine/api/labelTask/sub/assign', {
    params
  })
}


// (服务商)任务数据列表，标注中和质检不通过数据 
export const itemsForClient = (params) => {
  return axios.get('/welldbCombine/api/labelTask/itemsForClient', {
    params
  })
}



// (服务商)任务数据列表，标注中和质检不通过数据 
export const creatTag = (data) => {
  return axios.post('/welldbCombine/api/labelTask/detail/tag', {
    ...data
  })
}





// export const createTask = (params) => {
//   const user = store.state.userInfo
//   return axios.post('/welldbCombine/task', {
//     moveToQuery: true,
//     params: cleanParams({ ...params, createUserId: user.userId })
//   })
// }
